import * as React from 'react';
import styled from 'styled-components'
import {ConstBreakPoint} from "../../../../../config/styles_const/styles_const";

interface IProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
}

const MonthDaysWrapperDefault: React.FC<IProps> = (props) => {

    const { ...DivProps } = props;

    return (<div {...DivProps} />)

};

const MonthDaysWrapper = styled(MonthDaysWrapperDefault)`
    width: 120px;
    margin-right: 50px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        width: 120px;
        margin-right: 50px;
        &:last-child {
            margin-right: 0;
        }
    }
`;

export default MonthDaysWrapper;



// WEBPACK FOOTER //
// ./src/presentation/common/atom/wrapper/datepicker_wrapper/month_days_wrapper.tsx